const DataHistory = () => import('../../components/Tenant/DataHistory/DataHistory')

export default {
  path: 'tenant-data-history',
  redirect: 'tenant-data-history',
  component: {
    template: '<router-view></router-view>',
  },
  name: 'tenant-data-history',
  meta: {'permissions': 'view-tenant-data-history'},
  children: [
    {
      path: '/',
      component: DataHistory,
    },
  ],
};
